<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary"
    class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>
        {{ Object.entries(this.data).length > 1 ? "UPDATE" : "ADD NEW" }}
        PRODUCT
      </h4>
      <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">
      <div class="p-6">
        <div v-if="Object.entries(this.data).length <= 1" class="vx-row w-full">
          <div class="vx-col w-full" style="font-size: 90%">
            Product Category
            <v-select autocomplete :options="data_options_product_category" @input="
              getProductList();
            SetProductName();
            " v-model="dataProductCategoryId" />
          </div>
          <div class="vx-col w-full" style="font-size: 90%">
            <br />Product
            <v-select autocomplete :options="data_options_product" @input="
              getProductData();
            SetProductName();
            " v-model="dataProductId" />
            <!-- <vs-button class="vx-col w-full mt-4" @click="(activePrompt = true), openPrompt()" color="primary"
              type="border">Product not in the list?</vs-button> -->
          </div>
        </div>

        <br v-if="Object.entries(this.data).length <= 1" />
        <hr v-if="Object.entries(this.data).length <= 1" class="mt-5 w-full" />
        <div class="vx-row w-full" v-if="dataUom">
          <div class="vx-col w-full">
            <vs-input label="Product (Translated if not edited)" v-model="dataDescription" class="mt-4 w-full"
              name="name" />
          </div>
          <div class="vx-col w-1/2">
            <vs-input :label="'Quantity (' + dataUom + ')'" v-model="dataQuantity"
              @input="SetVolumeTotalAndPriceTotalLive" style="
                background-color: #ffff99;
                border: 1px solid #ffff99;
                border-radius: 5px;
              " class="mt-1 w-full" name="quantity" />
          </div>
          <div class="vx-col w-1/2">
            <vs-input :label="'Current Stock (' + dataUom + ')'" v-model="currentStock" class="mt-1 w-full" disabled />
          </div>
          <div class="vx-col w-1/2" v-if="dataVolume">
            <vs-input label="Unit Volume (m3)" v-model="dataVolume" class="mt-1 w-full" name="unitvolume" disabled />
          </div>
          <div class="vx-col w-1/2" v-if="dataVolume">
            <vs-input label="Volume Total (m3)" v-model="dataVolumeTotal" class="mt-1 w-full" name="volume" disabled />
          </div>
          <!--ICI2025-->
          <div class="vx-col w-1/2" v-if="dataSurface != 0">
            <vs-input label="Unit Area (m2)" v-model="dataSurface" class="mt-1 w-full" name="unitsurface" disabled />
          </div>
          <div class="vx-col w-1/2" v-if="dataSurface != 0">
            <vs-input label="Area Total (m2)" v-model="dataSurfaceTotal" class="mt-1 w-full" name="surface" disabled />
          </div>
          <div class="vx-col w-1/2" v-if="dataLength != 0">
            <vs-input label="Unit Area (ml)" v-model="dataLength" class="mt-1 w-full" name="unitsurface" disabled />
          </div>
          <div class="vx-col w-1/2" v-if="dataLength != 0">
            <vs-input label="Area Total (ml)" v-model="dataLengthTotal" class="mt-1 w-full" name="surface" disabled />
          </div>
          <!--
          <div class="vx-col w-1/2">
            <vs-input :label="'Current Stock (' + dataUom + ')'" v-model="currentStock" class="mt-4 w-full" disabled />
          </div>
          <div class="vx-col w-1/2" v-if="dataVolume">
            <vs-input label="Unit Volume (m3)" v-model="dataVolume" class="mt-4 w-full" name="unitvolume" disabled />
          </div>
          <div class="vx-col w-1/2" v-if="dataVolume">
            <vs-input label="Volume Total (m3)" v-model="dataVolumeTotal" class="mt-4 w-full" name="volume" disabled />
          </div>
          <div class="vx-col w-1/2" v-if="dataSurface != 0">
            <vs-input label="Unit Area (m2)" v-model="dataSurface" class="mt-4 w-full" name="unitsurface" disabled />
          </div>
          <div class="vx-col w-1/2" v-if="dataSurface != 0">
            <vs-input label="Area Total (m2)" v-model="dataSurfaceTotal" class="mt-4 w-full" name="surface" disabled />
          </div>
          <div class="vx-col w-1/2" v-if="dataSurface != 0">
            <vs-input label="Unit Area (ml)" v-model="dataLength" class="mt-4 w-full" name="unitsurface" disabled />
          </div>
          <div class="vx-col w-1/2" v-if="dataSurface != 0">
            <vs-input label="Area Total (ml)" v-model="dataLengthTotal" class="mt-4 w-full" name="surface" disabled />
          </div>-->
        </div>
        <hr v-if="dataUom" class="mt-5 w-full" />
        <div v-if="dataUom" class="vx-row w-full mt-4">
          <div class="vs-con-loading__container vx-col w-1/2">
            <vs-button v-if="DataRefPricePcs != 'n/a' &&
              DataRefPricePcs != null &&
              DataRefPricePcs != 'NaN' &&
              DataRefPricePcs != 0
            " color="dark" class="mr-6" style="text-align: left; font-size: 12px" @click="applyRefPrice()"><b>Ref.
                price</b><br /><small>{{ DataRefPricem3 }} €/m3 = {{ DataRefPricePcs }} €/{{
                  dataUom
                }}</small></vs-button>
          </div>
          <div class="vs-con-loading__container vx-col w-1/2">
            <vs-button v-if="DataLatestPricem3 != 'n/a' &&
              DataLatestPricem3 != null &&
              DataLatestPricem3 != 'NaN' &&
              DataLatestPricem3 != 0
            " color="dark" class="mr-6" style="text-align: left; font-size: 12px" @click="applyLatestPrice()"><b>Last
                price</b><br /><small>{{ DataLatestPricem3 }} €/m3 = {{ DataLatestPricePcs }} €/{{
                  dataUom
                }}</small></vs-button>
          </div>
        </div>
        <div v-if="dataUom &&
          DataLatestPricePcs != null &&
          DataLatestPricePcs != 'NaN' &&
          DataLatestPricePcs != ''
        " class="vx-row w-full mt-4">
          <!--<div class="vs-con-loading__container vx-col w-1/2">
          <b>Client last price</b><br/><small>{{ DataLatestPricem3 }} €/m3 = {{ DataLatestPricePcs }} €/{{ dataUom }}</small>
          </div>
          <div class="vs-con-loading__container vx-col w-1/2">
              <vs-button color="dark" type="border" class="mr-6" style="text-align:left;font-size:12px" @click="applyLatestPrice()"><b>Last price</b><br/><small>{{ DataLatestPricem3 }} €/m3 = {{ DataLatestPricePcs }} €/{{ dataUom }}</small></vs-button>
          </div>-->
        </div>
        <div v-if="dataUom" class="vx-row w-full mt-2">
          <div class="vs-con-loading__container vx-col w-full">
            <vs-button color="warning" class="w-full" style="text-align: left; font-size: 12px"
              @click="openCatalogPrice()"><b>CATALOG</b><br/><small v-if="catalogPricePcs || catalogPriceM3">{{ catalogPriceM3 ? catalogPriceM3 + ' €/m3' : '' }}{{ catalogPriceM3 && catalogPricePcs ? ' = ' : '' }}{{ catalogPricePcs ? catalogPricePcs + ' €/' + dataUom : '' }} ({{ catalogIncotermLabel }})</small></vs-button>
          </div>
        </div>
        <div v-if="dataUom" class="vx-row w-full">
          <div v-if="dataVolume" id="div-with-loading-eur" class="vs-con-loading__container vx-col w-1/3">
            <vs-input :label="'(€/m3)'" v-model="dataUnitPricePerM3" style="
                background-color: #ffff99;
                border: 1px solid #ffff99;
                border-radius: 5px;
              " @input="EditUnitPricePerM3" class="mt-4 w-full" name="unit price" v-validate="'decimal'" />
          </div>
          <div id="div-with-loading-eur" class="vs-con-loading__container vx-col w-1/3">
            <vs-input :label="'(€/' + dataUom + ')'" v-model="dataUnitPrice" style="
                background-color: #ffff99;
                border: 1px solid #ffff99;
                border-radius: 5px;
              " @input="EditCurrency(1); UpdateUnitPricePerM3()" class="mt-4 w-full" name="unit price"
              v-validate="'decimal'" />
          </div>
          <div id="div-with-loading-ron" class="vs-con-loading__container vx-col w-1/3">
            <vs-input :label="'(RON/' + dataUom + ')'" v-model="dataUnitPriceRon"
              @input="EditCurrency(2); UpdateUnitPricePerM3()" class="mt-4 w-full" name="unit price"
              v-validate="'decimal'" />
          </div>
        </div>
        <div v-if="catalogVolumeNote" class="vx-row w-full">
          <div class="vx-col w-full">
            <small style="color: #b8860b; display: block; line-height: 1.3; margin-top: 6px">{{ catalogVolumeNote }}</small>
          </div>
        </div>
        <!-- ICI2025 -->
        <div class="vx-row w-full">
          <div v-if="containsWidthLength" class="vs-con-loading__container vx-col w-1/3">
            <vs-input :label="'(€/m²)'" v-model="dataUnitPricePerM2" @input="EditUnitPricePerM2" class="mt-4 w-full"
              style="background-color: #ffff99; border-radius: 5px;" />
          </div>
          <div v-if="containsLength" class="vs-con-loading__container vx-col w-1/3">
            <vs-input :label="'(€/ml)'" v-model="dataUnitPricePerML" @input="EditUnitPricePerML" class="mt-4 w-full"
              style="background-color: #ffff99; border-radius: 5px;" />
          </div>
        </div>

        <div class="vx-row w-full">
          <div class="vx-col w-1/2" v-if="dataUnitPrice">
            <vs-input label="Increase/decrease (%)" v-model="dataMajoration" style="
                background-color: #eee;
                border: 1px solid #eee;
                border-radius: 5px;
              " class="mt-4 w-full" v-validate="'decimal'" />
          </div>
          <div class="vx-col w-1/2" v-if="dataUnitPrice">
            <vs-button v-if="dataMajoration > 0" color="green" class="mt-10"
              @click="applyMajoration()"><small>Apply</small></vs-button>
            <vs-button v-else-if="dataMajoration < 0" color="warning" class="mt-10"
              @click="applyMajoration()"><small>Apply</small></vs-button>
          </div>
        </div>
        <div class="vx-row w-full">
          <div class="vx-col w-1/2">
            <vs-input label="Total Ex VAT / HT (€)" v-model="dataTotalPrice" v-validate="'required'" class="mt-4 w-full"
              name="price" disabled />
          </div>
          <div class="vx-col w-1/2">
            <vs-input label="Total Ex VAT / HT (RON)" v-model="dataTotalPriceRon" v-validate="'required'" class="mt-4 w-full"
              name="price" disabled />
          </div>
        </div>
        <!-- TTC (Inc VAT) — affiché uniquement si TVA > 0 -->
        <div class="vx-row w-full" v-if="incVatVisible">
          <div class="vx-col w-1/2">
            <vs-input :label="'Total Inc VAT (€) — VAT ' + currentTvaPct + '%'" v-model="ttcEurEdit"
              @input="onEditTtcEur" class="mt-4 w-full"
              style="background-color: #ffff99; border: 1px solid #ffff99; border-radius: 5px;" />
          </div>
          <div class="vx-col w-1/2">
            <vs-input :label="'Total Inc VAT (RON) — VAT ' + currentTvaPct + '%'" v-model="ttcRonEdit"
              @input="onEditTtcRon" class="mt-4 w-full"
              style="background-color: #ffff99; border: 1px solid #ffff99; border-radius: 5px;" />
          </div>
        </div>
      </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">Submit</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancel</vs-button>
    </div>

    <vs-prompt @cancel="clearValMultiple" @accept="acceptAlert" @close="closePrompt" :is-valid="validName"
      :active.sync="activePrompt">
      <div class="con-exemple-prompt p-2">
        Add New Product .
        <!-- CATEGORY -->
        <vs-select v-model="dataCategoryProd" @input="changeNameProd" label="Category" class="mt-5 w-full"
          name="category">
          <vs-select-item :key="item.id" :value="item.id" :text="item.name_en"
            v-for="item in data_options_categories" />
        </vs-select>
        <span class="text-danger text-sm" v-show="errors.has('category')">{{
          errors.first("category")
        }}</span>
        <!-- SHAPE -->
        <div class="vx-row">
          <div class="vx-col w-1/2">
            <vs-input label="Shape" v-model="dataShapeProd" class="mt-5 w-full" name="shape" disabled
              v-validate="'required'" />
            <span class="text-danger text-sm" v-show="errors.has('shape')">{{
              errors.first("shape")
            }}</span>
          </div>
          <!-- UOMS -->
          <div v-if="uomLockedProd" class="vx-col w-1/2">
            <vs-select v-model="dataUomProd" @change="getOptionsUoms" label="Unit of Measure" class="mt-5 w-full"
              name="uom" disabled>
              <vs-select-item :key="item.id" :value="item.id" :text="item.name_en" v-for="item in data_options_uoms" />
            </vs-select>
            <span class="text-danger text-sm" v-show="errors.has('category')">{{
              errors.first("category")
            }}</span>
          </div>
          <div v-else class="vx-col w-1/2">
            <vs-select v-model="dataUomProd" @change="getOptionsUoms" label="Unit of Measure" class="mt-5 w-full"
              name="uom">
              <vs-select-item :key="item.id" :value="item.id" :text="item.name_en" v-for="item in data_options_uoms" />
            </vs-select>
            <span class="text-danger text-sm" v-show="errors.has('category')">{{
              errors.first("category")
            }}</span>
          </div>
        </div>
        <!-- NAME -->
        <vs-input v-if="dataShapeIdProd === 5 || dataShapeIdProd === 6 || dataShapeIdProd === 8" label="Name EN"
          v-model="dataNameProdEN" class="mt-5 w-full" name="name" v-validate="'required'" />
        <vs-input v-if="dataShapeIdProd === 5 || dataShapeIdProd === 6 || dataShapeIdProd === 8" label="Name FR"
          v-model="dataNameProdFR" class="mt-5 w-full" name="name" v-validate="'required'" />
        <vs-input v-if="dataShapeIdProd === 5 || dataShapeIdProd === 6 || dataShapeIdProd === 8" label="Name RO"
          v-model="dataNameProdRO" class="mt-5 w-full" name="name" v-validate="'required'" />
        <vs-input v-if="dataShapeIdProd === 5 || dataShapeIdProd === 6 || dataShapeIdProd === 8" label="Name ES"
          v-model="dataNameProdES" class="mt-5 w-full" name="name" v-validate="'required'" />
        <vs-input v-if="dataShapeIdProd === 5 || dataShapeIdProd === 6 || dataShapeIdProd === 8" label="Name DE"
          v-model="dataNameProdDE" class="mt-5 w-full" name="name" v-validate="'required'" />
        <vs-input v-if="dataShapeIdProd === 5 || dataShapeIdProd === 6 || dataShapeIdProd === 8" label="Name NL"
          v-model="dataNameProdNL" class="mt-5 w-full" name="name" v-validate="'required'" />
        <vs-input v-if="dataShapeIdProd !== 8 && dataShapeIdProd !== 5 && dataShapeIdProd !== 6" label="Name"
          v-model="dataNameProdEN" class="mt-5 w-full" name="name_en" disabled />
        <span class="text-danger text-sm" v-show="errors.has('name_en')">{{
          errors.first("name_en")
        }}</span>
        <!-- ROULEAU -->
        <div class="vx-row">
          <div class="vx-col w-1/2">
            <vs-input v-if="dataShapeIdProd === 7" label="Roller Length (m)" @input="changeNameProd"
              v-model="dataRollerLengthProd" class="mt-5 w-full" name="rollerlength" v-validate="'decimal'" />
            <span class="text-danger text-sm" v-show="errors.has('rollerlength')">{{ errors.first("rollerlength")
            }}</span>
          </div>
          <div class="vx-col w-1/2">
            <vs-input v-if="dataShapeIdProd === 7" label="Stakes Height (m)" @input="changeNameProd"
              v-model="dataLengthProd" class="mt-5 w-full" name="length" v-validate="'decimal'" />
            <span class="text-danger text-sm" v-show="errors.has('length')">{{
              errors.first("length")
            }}</span>
          </div>
        </div>
        <!-- LENGTH -->
        <div class="vx-row">
          <div class="vx-col w-1/2">
            <vs-input v-if="dataShapeIdProd === 1 ||
              dataShapeIdProd === 2 ||
              dataShapeIdProd === 3 ||
              dataShapeIdProd === 4
            " label="Length (m)" @input="changeNameProd" v-model="dataLengthProd" class="mt-5 w-full" name="length"
              v-validate="'decimal'" />
            <span class="text-danger text-sm" v-show="errors.has('length')">{{
              errors.first("length")
            }}</span>
          </div>
          <div class="vx-col w-1/2">
            <!-- DIAMETER -->
            <vs-input v-if="dataShapeIdProd === 1" label="Diameter (cm)" @input="changeNameProd"
              v-model="dataDiameterProd" class="mt-5 w-full" name="diameter" v-validate="'decimal'" />
            <span class="text-danger text-sm" v-show="errors.has('diameter')">{{
              errors.first("diameter")
            }}</span>
          </div>
        </div>
        <!-- SPACING -->
        <div class="vx-row">
          <div class="vx-col w-1/3">
            <vs-input v-if="dataShapeIdProd === 7" label="Sp. Min. (cm)" @input="changeNameProd"
              v-model="dataSpacing_MinProd" class="mt-5 w-full" name="spacing_min" v-validate="'decimal'" />
            <span class="text-danger text-sm" v-show="errors.has('spacing')">{{
              errors.first("spacing")
            }}</span>
          </div>
          <div class="vx-col w-1/3">
            <vs-input v-if="dataShapeIdProd === 7" label="Sp. Max. (cm)" @input="changeNameProd"
              v-model="dataSpacing_MaxProd" class="mt-5 w-full" name="spacing_max" v-validate="'decimal'" />
            <span class="text-danger text-sm" v-show="errors.has('spacing')">{{
              errors.first("spacing")
            }}</span>
          </div>
          <div class="vx-col w-1/3">
            <vs-input v-if="dataShapeIdProd === 7" label="Sp. Avg. (cm)" v-model="dataSpacing_AvgProd"
              class="mt-5 w-full" name="spacing_avg" v-validate="'decimal'" disabled />
            <span class="text-danger text-sm" v-show="errors.has('spacing')">{{
              errors.first("spacing")
            }}</span>
          </div>
        </div>
        <!-- PERIMETER -->
        <div class="vx-row">
          <div class="vx-col w-1/3">
            <vs-input v-if="dataShapeIdProd === 2 ||
              dataShapeIdProd === 3 ||
              dataShapeIdProd === 7
            " label="P. Min. (cm)" @input="changeNameProd" v-model="dataPerimeter_MinProd" class="mt-5 w-full"
              name="perimeter_min" v-validate="'decimal'" />
            <span class="text-danger text-sm" v-show="errors.has('radius')">{{
              errors.first("radius")
            }}</span>
          </div>
          <div class="vx-col w-1/3">
            <vs-input v-if="dataShapeIdProd === 2 ||
              dataShapeIdProd === 3 ||
              dataShapeIdProd === 7
            " label="P. Max. (cm)" @input="changeNameProd" v-model="dataPerimeter_MaxProd" class="mt-5 w-full"
              name="perimeter_max" v-validate="'decimal'" />
            <span class="text-danger text-sm" v-show="errors.has('radius')">{{
              errors.first("radius")
            }}</span>
          </div>
          <div class="vx-col w-1/3">
            <vs-input v-if="dataShapeIdProd === 2 ||
              dataShapeIdProd === 3 ||
              dataShapeIdProd === 7
            " label="P. Avg. (cm)" v-model="dataPerimeter_AvgProd" class="mt-5 w-full" name="perimeter_avg"
              v-validate="'decimal'" disabled />
            <span class="text-danger text-sm" v-show="errors.has('radius')">{{
              errors.first("radius")
            }}</span>
          </div>
        </div>
        <!-- Height -->
        <div class="vx-row">
          <div class="vx-col w-1/2">
            <vs-input v-if="dataShapeIdProd === 4" label="Height (cm)" @input="changeNameProd" v-model="dataHeightProd"
              class="mt-5 w-full" name="height" v-validate="'decimal'" />
            <span class="text-danger text-sm" v-show="errors.has('height')">{{
              errors.first("height")
            }}</span>
          </div>
          <!-- Width -->
          <div class="vx-col w-1/2">
            <vs-input v-if="dataShapeIdProd === 4" label="Width (cm)" @input="changeNameProd" v-model="dataWidthProd"
              class="mt-5 w-full" name="width" v-validate="'decimal'" />
            <span class="text-danger text-sm" v-show="errors.has('width')">{{
              errors.first("width")
            }}</span>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-1/2">
            <vs-input v-if="dataShapeIdProd === 7" label="Radius 1 Stake (cm)" v-model="dataRadiusProd"
              class="mt-5 w-full" name="radius" disabled />
            <span class="text-danger text-sm" v-show="errors.has('volume')">{{
              errors.first("volume")
            }}</span>
          </div>

          <div class="vx-col w-1/2">
            <vs-input v-if="dataShapeIdProd === 7" label="N. Stakes per Roller" @input="changeNameProd(true)"
              v-model="dataNbStakesProd" class="mt-5 w-full" name="nbstake" />
            <span class="text-danger text-sm" v-show="errors.has('nbstake')">{{
              errors.first("nbstake")
            }}</span>
          </div>
        </div>
        <!-- Volume -->
        <div class="vx-row">
          <div class="vx-col w-full">
            <vs-input v-if="dataShapeIdProd === 8" label="Volume (m3)" v-model="dataVolumeProd" class="mt-5 w-full"
              name="vol" v-validate="'decimal'" />
            <span v-if="dataShapeIdProd === 8" class="text-danger text-sm" v-show="errors.has('vol')">{{
              errors.first("vol") }}</span>
            <vs-input v-if="dataShapeIdProd === 1 ||
              dataShapeIdProd === 2 ||
              dataShapeIdProd === 3 ||
              dataShapeIdProd === 4 ||
              dataShapeIdProd === 7
            " label="Volume (m3)" v-model="dataVolumeProd" class="mt-5 w-full" name="volume" disabled />
            <span v-if="dataShapeIdProd === 1 ||
              dataShapeIdProd === 2 ||
              dataShapeIdProd === 3 ||
              dataShapeIdProd === 4 ||
              dataShapeIdProd === 7
            " class="text-danger text-sm" v-show="errors.has('volume')">{{ errors.first("volume") }}</span>
          </div>
        </div>
      </div>
    </vs-prompt>

    <!-- Catalog Price Suggestion Popup -->
    <vs-popup title="" :active.sync="catalogPricePopup">
      <div style="padding: 20px;">
        <!-- Warning Banner -->
        <div style="background: linear-gradient(135deg, #fff3cd 0%, #ffe69c 100%); border: 2px solid #ffc107; border-radius: 10px; padding: 16px; margin-bottom: 20px; text-align: center;">
          <p style="color: #664d03; font-weight: 800; font-size: 18px; margin: 0; letter-spacing: 1px;">
            &#9888; WARNING: PRICES ARE IN TEST
          </p>
          <hr style="border: none; border-top: 1px solid #e0c36a; margin: 10px 0;" />
          <p style="color: #664d03; font-size: 13px; margin: 0; line-height: 1.6;">
            If a price appears incorrect, please report it to
            <a href="mailto:CONTACT@CODESINN.COM" style="font-weight: bold; color: #664d03; text-decoration: underline;">CONTACT@CODESINN.COM</a><br/>
            These prices will be used by the <b>AI agent</b> for automated quote responses.
          </p>
        </div>

        <!-- Price Details -->
        <div style="background: #f8f9fa; border-radius: 8px; padding: 16px; margin-bottom: 20px;">
          <div style="display: flex; justify-content: space-between; padding: 6px 0; border-bottom: 1px solid #e9ecef;">
            <span style="color: #6c757d; font-size: 13px;">Category</span>
            <span style="font-weight: 600; font-size: 13px;">{{ catalogCategoryName }}</span>
          </div>
          <div style="display: flex; justify-content: space-between; padding: 6px 0; border-bottom: 1px solid #e9ecef;">
            <span style="color: #6c757d; font-size: 13px;">Incoterm</span>
            <span style="font-weight: 600; font-size: 13px;">{{ catalogIncotermLabel }}</span>
          </div>
          <div v-if="catalogPriceM3" style="display: flex; justify-content: space-between; padding: 8px 0; margin-top: 4px;">
            <span style="font-weight: 700; font-size: 14px; color: #333;">Catalog Price</span>
            <span style="font-weight: 800; font-size: 16px; color: #2196f3;">{{ catalogPriceM3 }} EUR/m3</span>
          </div>
          <!-- Le prix d'une pièce n'est pas toujours dérivable : une famille tarifée au m² ou
               au m³ n'a pas de « prix à la pièce ». On affiche alors le prix du tarif AVEC son
               unité, plutôt qu'un chiffre qu'on ferait passer pour un prix à la pièce. -->
          <div v-if="catalogPricePcs" style="display: flex; justify-content: space-between; padding: 8px 0;">
            <span style="font-weight: 700; font-size: 14px; color: #333;">
              Unit Price ({{ dataUom }})
              <small v-if="catalogPriceUnit === 'linear_m' && catalogRollLength" style="display: block; color: #6c757d; font-weight: 400;">
                rouleau de {{ catalogRollLength }} m — tarif au mètre linéaire
              </small>
            </span>
            <span style="font-weight: 800; font-size: 16px; color: #2196f3;">{{ catalogPricePcs }} EUR/{{ dataUom }}</span>
          </div>
          <div v-else-if="catalogPriceUnit && catalogPriceUnit !== 'piece'" style="display: flex; justify-content: space-between; padding: 8px 0;">
            <span style="font-weight: 700; font-size: 14px; color: #333;">Tarif</span>
            <span style="font-weight: 600; font-size: 13px; color: #6c757d;">au {{ catalogPriceUnit === 'm2' ? 'm²' : catalogPriceUnit === 'm3' ? 'm³' : catalogPriceUnit }} — pas de prix à la pièce</span>
          </div>
          <div v-if="catalogPcsPerPallet" style="display: flex; justify-content: space-between; padding: 6px 0; border-top: 1px solid #e9ecef;">
            <span style="color: #6c757d; font-size: 13px;">Pieces / pallet</span>
            <span style="font-weight: 600; font-size: 13px;">{{ catalogPcsPerPallet }}</span>
          </div>
          <div v-if="catalogSourceCell" style="display: flex; justify-content: space-between; padding: 6px 0;">
            <span style="color: #6c757d; font-size: 13px;">Source</span>
            <span style="font-weight: 600; font-size: 13px;">{{ catalogSourceCell }}</span>
          </div>
        </div>

        <!-- Actions -->
        <div style="display: flex; gap: 10px;">
          <vs-button color="success" class="w-full" @click="applyCatalogPrice()" style="font-weight: 700;">Apply this price</vs-button>
          <vs-button type="border" color="dark" @click="catalogPricePopup = false" style="min-width: 100px;">Close</vs-button>
        </div>
      </div>
    </vs-popup>

  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import axios from "@/axios.js";
import moduleOperationList from "@/store/operation/moduleOperationList.js";
import moduleDataListProduct from "@/store/products/product/moduleDataList.js";
import vSelect from "vue-select";
import pricingZones from "@/mixins/pricingZones";
import eurRonRate from "@/mixins/eurRonRate";

export default {
  mixins: [pricingZones, eurRonRate],
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true,
    },
    data: {
      type: Object,
      default: () => { },
    },
  },
  components: {
    VuePerfectScrollbar,
    "v-select": vSelect,
  },
  data() {
    return {
      /* ICI2025 */
      containsWidthLength: false,
      containsLength: false,
      dataUnitPricePerM2: 0,
      dataUnitPricePerML: 0,
      updatingFromM2: false,
      updatingFromM3: false,
      dataSurface: "",
      dataSurfaceTotal: "",
      dataLength: "",
      dataLengthTotal: "",
      dataWidth: "",

      displayExport: false,
      dataId: null,
      data_options_product_category: [],
      dataProductCategoryId: "",
      data_options_product: [],
      dataProductId: "",
      dataVolume: "",
      dataQuantity: "",
      dataVolumeTotal: "",
      currentStock: null,
      dataUnitPricePerM3: null,
      dataTotalPrice: "",
      dataTotalPriceRon: "",
      dataUom: "",
      dataUnitPrice: "",
      dataUnitPriceRon: "",
      ttcRonEdit: "",
      ttcEurEdit: "",
      dataName: "",
      dataDescription: "",
      dataTheoreticalPrice: "",
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },

      activePrompt: false,
      backgroundLoading: "primary",
      colorLoading: "#fff",
      dataNameProdEN: "",
      dataNameProdFR: "",
      dataNameProdRO: "",
      dataNameProdES: "",
      dataNameProdNL: "",
      dataNameProdDE: "",
      dataLengthProd: "",
      dataRadiusProd: "",
      dataShapeProd: "",
      dataShapeIdProd: "",
      dataDiameterProd: "",
      dataHeightProd: "",
      dataWidthProd: "",
      dataNbStakesProd: "",
      dataPerimeter_MinProd: "",
      dataPerimeter_MaxProd: "",
      dataPerimeter_AvgProd: "",
      dataCategoryProd: null,
      dataUomProd: null,
      dataVolumeProd: "",
      dataSpacing_MaxProd: "",
      dataRollerLengthProd: "",
      uomLockedProd: "",
      data_options_uoms: [],
      data_options_categories: [],
      DataRefPricem3: null,
      DataRefPricePcs: null,
      DataLatestPricem3: null,
      DataLatestPricePcs: null,
      dataMajoration: null,
      dataUnitPricePerM3: null,
      // Catalog Price Suggestion
      catalogPricePopup: false,
      catalogPriceM3: null,
      catalogPricePcs: null,
      /** Unité DU TARIF ('piece', 'linear_m', 'm2', 'm3') — dit ce que price_per_unit mesure. */
      catalogPriceUnit: null,
      catalogRollLength: null,
      catalogPcsPerPallet: null,
      // Volume (m³/UoM) que le catalogue a utilisé pour son €/m³ (volume XLSX de référence).
      // Sert à convertir €/m³ → €/UoM sans dépendre de product.volume (parfois faux côté ERP).
      catalogVolume: null,
      catalogSourceCell: null,
      catalogIncotermLabel: '',
      catalogCategoryName: '',
      lastProductData: null,
    };
  },
  watch: {
    async isSidebarActive(val) {
      if (!val) return;

      this.$vs.loading();

      if (Object.entries(this.data).length === 1) {
        this.initValues();
        this.$validator.reset();
        this.dataIdOperation = this.data.idoperation;
      } else {
        try {
          await this.getStockToday(this.data.operations_products.idproduct);
          await this.getRefPrice();
          if (this.data.operations_products.unit_price_ron) {
            await this.getLatestPrice();
          }

          // Réinitialiser dataProductId pour éviter les confusions
          this.dataProductId = "";

          this.dataIdOperation = this.data.operations_products.idoperation;
          this.dataDescription = this.data.operations_products.description;
          this.dataName =
            this.data.productcategory.name_en + " " + this.data.name_en;
          this.dataQuantity = Math.abs(this.data.operations_products.quantity);
          this.dataVolume = this.data.volume;
          this.dataVolumeTotal = this.data.volume * this.dataQuantity;
          this.dataUom = this.data.uomsreference.name_en;
          this.dataTheoreticalPrice = this.data.productcategory.price;

          if (this.data.operations_products.unit_price) {
            this.dataUnitPrice = Math.abs(this.data.operations_products.unit_price);
            this.dataTotalPrice = this.dataUnitPrice * this.dataQuantity;
          }
          if (this.data.operations_products.unit_price_ron) {
            this.dataUnitPriceRon = Math.abs(this.data.operations_products.unit_price_ron);
            this.dataTotalPriceRon = this.dataUnitPriceRon * this.dataQuantity;
          }
          if (this.dataVolume) this.dataUnitPricePerM3 = (this.dataUnitPrice / this.dataVolume).toFixed(2)

          /*ICI2025*/
          this.containsWidthLength = false
          this.containsLength = false
          this.dataWidth = this.data.width / 100
          this.dataLength = this.data.rollerlength || (this.data.length / 100);
          if (this.data.rollerlength || this.data.length) {
            this.containsLength = true;
            const effectiveLength = this.data.rollerlength || (this.data.length / 100);
            this.dataUnitPricePerML = (this.dataUnitPrice / effectiveLength).toFixed(4);
          }
          if (this.data.width && this.data.length) this.containsWidthLength = true;

          if (this.containsWidthLength && this.dataVolume) {
            this.dataSurface = (((this.data.width / 10000) * this.data.length)).toFixed(4);
            this.dataUnitPricePerM2 = ((this.dataUnitPricePerM3 * this.dataVolume) / this.dataSurface).toFixed(4);
          } else {
            this.dataUnitPricePerM2 = 0;
          }
          this.syncTtcEdits();
          this.initValues();
        } catch (error) {
          console.error(error);
        }
      }
      const loadingTimeout = setTimeout(() => this.$vs.loading.close(), 100);

    },
    currentTvaPct() {
      this.syncTtcEdits();
    },
  },
  computed: {
    /**
     * Écart entre le volume de la fiche ERP (géométrique, π·(Ø/2)²·L) et celui sur lequel le
     * catalogue XYLO-PRICING compte le produit (volume XLSX net commercial) — en %, au-delà
     * du bruit d'arrondi. Renvoie null quand il n'y a pas de quoi comparer.
     */
    catalogVolumeGapPct() {
      const erp = parseFloat(this.dataVolume);
      const cat = parseFloat(this.catalogVolume);
      if (!erp || !cat) return null;
      const pct = ((cat - erp) / erp) * 100;
      return Math.abs(pct) > 0.5 ? pct : null;
    },
    /** Ce que le €/m³ saisi vaudrait à la pièce dans la convention du catalogue. */
    catalogVolumePricePcs() {
      const m3 = parseFloat(this.dataUnitPricePerM3);
      const cat = parseFloat(this.catalogVolume);
      if (!m3 || !cat) return null;
      return (m3 * cat).toFixed(4);
    },
    /**
     * Les deux conventions de volume coexistent légitimement, mais un même « 450 €/m³ » n'y
     * vaut pas le même prix pièce — et l'écran ne le disait nulle part : un poteau Ø10-12 L2m
     * saisi à 450 €/m³ partait à 562,50 €/m³ (+25 %) tant que la conversion empruntait le
     * volume catalogue. On affiche l'écart et l'autre montant plutôt que d'en choisir un en
     * silence ; le prix du tarif, lui, s'obtient au bouton CATALOG (copie verbatim).
     */
    catalogVolumeNote() {
      const gap = this.catalogVolumeGapPct;
      if (gap === null || !this.dataUnitPricePerM3 || this.catalogVolumePricePcs == null) return null;
      const erp = parseFloat(this.dataVolume).toFixed(6);
      const cat = parseFloat(this.catalogVolume).toFixed(6);
      const uom = this.dataUom || "pcs";
      // Familles tarifées au m²/m³/ml — les ABOUTÉS en tête : `volume_per_unit` y est le volume
      // d'UNE UNITÉ DE PRIX (1 m² de lame 23 mm = 0,023 m³), pas d'une pièce. Le mettre en
      // regard du volume de la fiche ferait lire un « +182 % » qui ne veut rien dire.
      const unit = this.catalogPriceUnit;
      if (unit && unit !== "piece") {
        const label = unit === "m2" ? "m\u00b2" : unit === "m3" ? "m\u00b3"
          : unit === "linear_m" ? "m\u00e8tre lin\u00e9aire" : unit;
        return "\u26a0 Tarif au " + label + " : le volume catalogue (" + cat + " m\u00b3) est celui d'UNE " +
          "unit\u00e9 de prix, pas d'une pi\u00e8ce \u2014 \u00e0 ne pas comparer au volume de la fiche (" + erp +
          " m\u00b3). Le \u20ac/m\u00b3 saisi s'applique au volume de la fiche \u2192 " + this.dataUnitPrice +
          " \u20ac/" + uom + ".";
      }
      return "\u26a0 Volume : fiche " + erp + " m\u00b3 \u00b7 catalogue " + cat + " m\u00b3 (" +
        (gap > 0 ? "+" : "") + gap.toFixed(1) + " %). Le \u20ac/m\u00b3 saisi s'applique au volume de la " +
        "fiche \u2192 " + this.dataUnitPrice + " \u20ac/" + uom + " ; au volume catalogue il vaudrait " +
        this.catalogVolumePricePcs + " \u20ac/" + uom + ".";
    },
    currentTvaPct() {
      const raw = this.$parent && this.$parent.$parent ? this.$parent.$parent.dataTva : null;
      const p = parseFloat(raw);
      return isNaN(p) ? 0 : p;
    },
    incVatVisible() {
      return this.currentTvaPct > 0; // masqué à 0% (TTC = HT)
    },
    dataTotalPriceIncVat() {
      const ht = parseFloat(this.dataTotalPrice) || 0;
      return (ht * (1 + this.currentTvaPct / 100)).toFixed(2);
    },
    dataTotalPriceRonIncVat() {
      const ht = parseFloat(this.dataTotalPriceRon) || 0;
      return (ht * (1 + this.currentTvaPct / 100)).toFixed(2);
    },
    validName() {
      return this.dataNameProdEN;
    },
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
          // this.$validator.reset()
          // this.initValues()
        }
      },
    },
    isFormValid() {
      return (
        (!this.errors.any() && this.dataProductId.value && this.dataQuantity) ||
        (this.data.id && this.dataQuantity)
      );
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    },
  },
  methods: {
    /*ICI2025*/
    EditUnitPricePerM2() {
      if (this.updatingFromM3) return;
      this.updatingFromM2 = true;
      if (this.dataSurface && this.dataVolume && this.dataUnitPricePerM2) {
        this.dataUnitPricePerM3 = ((this.dataUnitPricePerM2 * this.dataSurface) / this.dataVolume).toFixed(4);
        this.dataUnitPricePerML = (this.dataUnitPricePerM2 * this.dataWidth).toFixed(4);
        this.dataUnitPrice = (this.dataUnitPricePerM3 * this.dataVolume).toFixed(4);
        this.EditCurrency(1);
      }
      this.updatingFromM2 = false;
    },
    /*ICI2025*/
    EditUnitPricePerML() {
      if (this.updatingFromM3) return;
      this.updatingFromM2 = true;

      if (this.dataLength && this.dataVolume && this.dataUnitPricePerML) {
        this.dataUnitPricePerM3 = ((this.dataUnitPricePerML * this.dataLength) / this.dataVolume).toFixed(4);
        this.dataUnitPricePerM2 = ((this.dataUnitPricePerM3 * this.dataVolume) / this.dataSurface).toFixed(4);
        this.dataUnitPrice = (this.dataUnitPricePerM3 * this.dataVolume).toFixed(4);
        this.EditCurrency(1);
      }

      this.updatingFromM2 = false;
    },
    EditUnitPricePerM3() {
      if (this.updatingFromM2) return;
      this.updatingFromM3 = true;

      if (this.dataVolume) {
        // Le €/m³ saisi s'applique au volume AFFICHÉ (product.volume) — celui qui sert au volume
        // total, au total HT, au bouton « Ref. price » et à la conversion inverse €/UoM → €/m³.
        // Convertir avec le volume XLSX du catalogue rendait l'écran incohérent : sur un poteau dont
        // le volume catalogue vaut 1,25× le volume géométrique, saisir 450 €/m³ facturait 562,50 €/m³.
        this.dataUnitPrice = (this.dataUnitPricePerM3 * this.dataVolume).toFixed(4);
        this.EditCurrency(1);

        /*ICI2025*/
        if (this.dataSurface && this.dataVolume) {
          this.dataUnitPricePerM2 = ((this.dataUnitPricePerM3 * this.dataVolume) / this.dataSurface).toFixed(4);
        } else {
          this.dataUnitPricePerM2 = 0;
        }


        if (this.dataLength && this.dataVolume) {
          this.dataUnitPricePerML = (this.dataUnitPrice / this.dataLength).toFixed(4);
        } else {
          this.dataUnitPricePerML = 0;
        }
      }

      this.updatingFromM3 = false;
    },

    UpdateUnitPricePerM3() {
      if (this.dataVolume) this.dataUnitPricePerM3 = (this.dataUnitPrice / this.dataVolume).toFixed(2)
      if (this.dataSurface && this.dataVolume) {
        this.dataUnitPricePerM2 = ((this.dataUnitPricePerM3 * this.dataVolume) / this.dataSurface).toFixed(2);
      } else {
        this.dataUnitPricePerM2 = 0;
      }
      if (this.dataLength && this.dataVolume) {
        this.dataUnitPricePerML = (this.dataUnitPrice / this.dataLength).toFixed(4);
      } else {
        this.dataUnitPricePerML = 0;
      }
    },
    // Édition inverse LIVE depuis le TTC (RON) saisi : TTC → HT → prix unitaire RON puis €.
    onEditTtcRon() {
      const tva = this.currentTvaPct;
      const qty = parseFloat(this.dataQuantity);
      const ttc = parseFloat(this.ttcRonEdit);
      if (!qty || isNaN(ttc)) return;
      const htRon = ttc / (1 + tva / 100);
      this.dataUnitPriceRon = (htRon / qty).toFixed(4);
      const rate = parseFloat(localStorage.getItem("rate_eur_ron"));
      if (rate) this.dataUnitPrice = (this.dataUnitPriceRon / rate).toFixed(4);
      this.UpdateUnitPricePerM3();
      this.dataTotalPriceRon = (qty * this.dataUnitPriceRon).toFixed(4);
      this.dataTotalPrice = (qty * this.dataUnitPrice).toFixed(4);
      // MAJ du champ jumeau (€) sans réécrire le champ RON en cours de saisie
      this.ttcEurEdit = (parseFloat(this.dataTotalPrice) * (1 + tva / 100)).toFixed(2);
    },
    // Symétrique LIVE depuis le TTC (€) : TTC → HT → prix unitaire € puis RON.
    onEditTtcEur() {
      const tva = this.currentTvaPct;
      const qty = parseFloat(this.dataQuantity);
      const ttc = parseFloat(this.ttcEurEdit);
      if (!qty || isNaN(ttc)) return;
      const htEur = ttc / (1 + tva / 100);
      this.dataUnitPrice = (htEur / qty).toFixed(4);
      const rate = parseFloat(localStorage.getItem("rate_eur_ron"));
      if (rate) this.dataUnitPriceRon = (this.dataUnitPrice * rate).toFixed(4);
      this.UpdateUnitPricePerM3();
      this.dataTotalPrice = (qty * this.dataUnitPrice).toFixed(4);
      this.dataTotalPriceRon = (qty * this.dataUnitPriceRon).toFixed(4);
      // MAJ du champ jumeau (RON) sans réécrire le champ € en cours de saisie
      this.ttcRonEdit = (parseFloat(this.dataTotalPriceRon) * (1 + tva / 100)).toFixed(2);
    },
    // Recalcule les champs TTC éditables depuis le HT courant (autres modifs : prix, quantité, TVA).
    syncTtcEdits() {
      const tva = this.currentTvaPct;
      const htEur = parseFloat(this.dataTotalPrice) || 0;
      const htRon = parseFloat(this.dataTotalPriceRon) || 0;
      this.ttcEurEdit = (htEur * (1 + tva / 100)).toFixed(2);
      this.ttcRonEdit = (htRon * (1 + tva / 100)).toFixed(2);
    },
    applyMajoration() {
      let initialValue = "Initial Value = " + this.dataUnitPrice + " EUR";
      this.dataUnitPrice =
        (parseFloat(this.dataUnitPrice) +
          (parseFloat(this.dataUnitPrice) / 100) *
          parseFloat(this.dataMajoration)).toFixed(2);
      let finalValue = "Result = " + this.dataUnitPrice + " EUR";
      this.dataUnitPrice = parseFloat(this.dataUnitPrice);
      this.EditCurrency(1);
      if (parseFloat(this.dataMajoration) > 0) {
        this.$vs.notify({
          color: "success",
          title: "Price increase!",
          text:
            initialValue +
            "<br/>+" +
            this.dataMajoration +
            "%<br/>" +
            finalValue,
          time: 5000,
        });
      } else {
        this.$vs.notify({
          color: "warning",
          title: "Price reduction!",
          text:
            initialValue +
            "<br/>+" +
            this.dataMajoration +
            "%<br/>" +
            finalValue,
          time: 5000,
        });
      }
      this.UpdateUnitPricePerM3()
      this.dataMajoration = null;
    },
    getLatestPrice() {
      try {
        if (this.data.operations_products.idproduct) {
          axios
            .get(
              "/operation/getlastreferenceprice/" +
              localStorage.clientId +
              "/" +
              this.data.operations_products.idproduct
            )
            .then((response) => {
              //alert("1. "+response.data.lastprice)
              this.DataLatestPricem3 = response.data.lastprice;
              this.DataLatestPricePcs = (
                parseFloat(this.DataLatestPricem3) * this.dataVolume
              ).toFixed(2);
            });
        } else {
        }

      } catch (error) {
        try {
          axios
            .get(
              "/operation/getlastreferenceprice/" +
              localStorage.clientId +
              "/" +
              this.dataProductId.value
            )
            .then((response) => {
              // alert("2. "+response.data.lastprice)
              this.DataLatestPricem3 = response.data.lastprice;
              this.DataLatestPricePcs = (
                parseFloat(this.DataLatestPricem3) * this.dataVolume
              ).toFixed(2);
            });

        } catch (error) {

        }

      }
    },
    getRefPrice() {
      if (localStorage.clientReferencePrice)
        this.DataRefPricem3 = localStorage.clientReferencePrice;
      else this.DataRefPricem3 = "n/a";

      if (localStorage.clientReferencePrice)
        this.DataRefPricePcs = (
          parseFloat(localStorage.clientReferencePrice) * this.dataVolume
        ).toFixed(2);

    },
    applyLatestPrice() {
      this.dataUnitPrice = this.DataLatestPricePcs;
      this.EditCurrency(1);
      this.dataUnitPricePerM3 = this.DataLatestPricem3
      /* ICI2025 */
      if (this.dataSurface && this.dataVolume) {
        this.dataUnitPricePerM2 = ((this.dataUnitPricePerM3 * this.dataVolume) / this.dataSurface).toFixed(2);
      } else {
        this.dataUnitPricePerM2 = 0;
      }
    },
    applyRefPrice() {
      this.dataUnitPrice = this.DataRefPricePcs;
      this.EditCurrency(1);
      this.dataUnitPricePerM3 = localStorage.clientReferencePrice
      /* ICI2025 */
      if (this.dataSurface && this.dataVolume) {
        this.dataUnitPricePerM2 = ((this.dataUnitPricePerM3 * this.dataVolume) / this.dataSurface).toFixed(2);
      } else {
        this.dataUnitPricePerM2 = 0;
      }
    },
    showCatalogPriceSuggestion(productData) {
      const clientType = parseInt(localStorage.getItem('clientType'));
      if (!clientType) return;

      // clientType → zone XYLO-PRICING (source unique des prix, masters XLSX).
      const clientTypeMap = this.clientTypeMap; // dynamic incoterms (mixins/pricingZones)

      const mapping = clientTypeMap[clientType];
      if (!mapping) return;

      const idproduct = this.dataProductId && this.dataProductId.value;
      if (!idproduct) return;

      // Reset avant l'appel async pour qu'un ancien prix ne traîne pas.
      this.catalogPriceM3 = null;
      this.catalogPricePcs = null;
      this.catalogPcsPerPallet = null;
      this.catalogVolume = null;
      this.catalogSourceCell = null;
      this.catalogIncotermLabel = mapping.label;
      this.catalogCategoryName =
        (this.dataProductCategoryId && this.dataProductCategoryId.label) ||
        (productData.productcategory && productData.productcategory.name_en) || '';

      // givemeprice(idproduct, incoterm) via le proxy ERP (secret côté serveur).
      axios
        .get('/pricing/lookup', { params: { idproduct, incoterm: mapping.zone } })
        .then((response) => {
          const d = response.data || {};
          // Le garde portait sur price_per_m3 : une famille sans référence m³ n'avait donc
          // AUCUN prix catalogue, alors que son prix unitaire est parfaitement connu.
          if (!d.matched) return;
          this.catalogPriceM3 = d.price_per_m3 != null ? parseFloat(d.price_per_m3).toFixed(2) : null;
          this.catalogPricePcs = this.catalogPiecePrice(d);
          this.catalogPriceUnit = d.price_unit || 'piece';
          this.catalogRollLength = d.roll_length_m != null ? d.roll_length_m : null;
          this.catalogVolume = d.volume_per_unit != null ? parseFloat(d.volume_per_unit) : null;
          this.catalogPcsPerPallet = d.pieces_per_pallet != null ? d.pieces_per_pallet : null;
          this.catalogSourceCell = d.source_cell || null;
        })
        .catch(() => { /* pricing injoignable → CATALOG n'affiche simplement aucun prix */ });
    },
    /**
     * Le prix d'UNE pièce, à partir de la réponse du tarif.
     *
     * `price_per_unit` est exprimé dans l'unité de la FAMILLE, que `price_unit` annonce : à la
     * pièce pour la plupart, mais au MÈTRE LINÉAIRE pour les ganivelles — où une pièce est un
     * rouleau de 5 ou 10 m. Prendre l'un pour l'autre proposait de facturer un rouleau au prix
     * d'un mètre : 12,67 € au lieu de 63,34 €. Le tarif renvoie `price_per_roll` pour cela.
     *
     * Les instructions de l'agent IA (agentapi.controller.js) le disaient déjà ; ce panneau-ci
     * ne l'avait jamais appris.
     *
     * Familles au m² ou au m³ : on ne devine pas une pièce à partir d'une surface ou d'un
     * volume. On renvoie null, et l'écran affiche le prix avec son unité réelle.
     */
    catalogPiecePrice(d) {
      if (!d || d.price_per_unit == null) return null;
      const unit = d.price_unit || 'piece';
      if (unit === 'piece') return parseFloat(d.price_per_unit).toFixed(4);
      if (unit === 'linear_m') {
        if (d.price_per_roll != null) return parseFloat(d.price_per_roll).toFixed(4);
        if (d.roll_length_m > 0) return (parseFloat(d.price_per_unit) * d.roll_length_m).toFixed(4);
        return null;
      }
      return null;
    },
    applyCatalogPrice() {
      // Sans prix à la pièce dérivable (familles au m² / m³), on n'applique rien plutôt que
      // d'écrire un prix nul dans le devis.
      if (this.catalogPricePcs == null) {
        this.$vs.notify({ color: 'warning', title: 'Prix catalogue non applicable',
          text: 'Ce tarif est au ' + (this.catalogPriceUnit === 'm2' ? 'm²' : 'm³') + ', pas à la pièce — à saisir à la main.', time: 5000 });
        this.catalogPricePopup = false;
        return;
      }
      this.dataUnitPrice = this.catalogPricePcs;
      this.EditCurrency(1);
      this.dataUnitPricePerM3 = this.catalogPriceM3;
      /* ICI2025 */
      if (this.dataSurface && this.dataVolume) {
        this.dataUnitPricePerM2 = ((this.dataUnitPricePerM3 * this.dataVolume) / this.dataSurface).toFixed(2);
      } else {
        this.dataUnitPricePerM2 = 0;
      }
      if (this.dataLength && this.dataVolume) {
        this.dataUnitPricePerML = (this.dataUnitPrice / this.dataLength).toFixed(4);
      } else {
        this.dataUnitPricePerML = 0;
      }
      this.SetVolumeTotalAndPriceTotalLive();
      this.catalogPricePopup = false;
      this.$vs.notify({ color: 'success', title: 'Catalog Price Applied',
        text: this.catalogPricePcs + ' EUR/' + this.dataUom + (this.catalogPriceM3 ? ' — ' + this.catalogPriceM3 + ' EUR/m3' : '') + ' (' + this.catalogIncotermLabel + ')', time: 3000 });
    },
    openCatalogPrice() {
      if ((this.catalogPriceM3 && this.catalogPriceM3 != 0) || this.catalogPricePcs) {
        this.catalogPricePopup = true;
      } else if (this.lastProductData) {
        this.showCatalogPriceSuggestion(this.lastProductData);
        if (!this.catalogPricePopup) {
          this.$vs.notify({ color: 'warning', title: 'Catalog Price', text: 'No catalog price available for this client type / product combination.', time: 4000 });
        }
      } else {
        this.$vs.notify({ color: 'warning', title: 'Catalog Price', text: 'Please select a product first.', time: 3000 });
      }
    },
    submitDataProd() {
      this.$validator.validateAll().then((result) => {
        {
          var longueur = null;
          if (this.dataLengthProd > 0) {
            longueur = this.dataLengthProd * 100;
          } else {
            longueur = null;
          }

          let obj = {};
          if (this.dataShapeId == 5 || this.dataShapeId == 6) {
            obj = {
              id: this.dataIdProd,
              name_en: this.dataNameProdEN,
              name_fr: this.dataNameProdFR,
              name_ro: this.dataNameProdRO,
              name_de: this.dataNameProdDE,
              name_es: this.dataNameProdES,
              name_nl: this.dataNameProdNL,
              height: this.dataHeightProd,
              width: this.dataWidthProd,
              radius: this.dataRadiusProd,
              diameter: this.dataDiameterProd,
              length: longueur,
              isactive: "true",
              volume: this.dataVolumeProd,
              perimeter_min: this.dataPerimeter_MinProd,
              perimeter_max: this.dataPerimeter_MaxProd,
              perimeter_avg: this.dataPerimeter_AvgProd,
              idproductcategory: this.dataCategoryProd,
              iduomsreference: this.dataUomProd,
            };
          } else {
            obj = {
              id: this.dataIdProd,
              name_en: this.dataNameProdEN,
              name_fr: this.dataNameProdEN,
              name_ro: this.dataNameProdEN,
              name_de: this.dataNameProdEN,
              name_es: this.dataNameProdEN,
              name_nl: this.dataNameProdEN,
              height: this.dataHeightProd,
              width: this.dataWidthProd,
              radius: this.dataRadiusProd,
              diameter: this.dataDiameterProd,
              length: longueur,
              isactive: "true",
              volume: this.dataVolumeProd,
              perimeter_min: this.dataPerimeter_MinProd,
              perimeter_max: this.dataPerimeter_MaxProd,
              perimeter_avg: this.dataPerimeter_AvgProd,
              idproductcategory: this.dataCategoryProd,
              iduomsreference: this.dataUomProd,
            };
          }
          delete obj.id;

          this.$store
            .dispatch("dataListProduct/createItem", obj)
            .catch((err) => {
              console.error(err);
            });
          this.$vs.notify({
            color: "success",
            title: "Product Created!",
            text: "The Product was successfully added",
          });
          this.clearValMultiple();
          this.$parent.$parent.toggleDataSidebar(true);
          this.dataProductCategoryId = null;
        }
      });
    },
    changeNameProd(isEditingTheNbOfStake = false) {
      //this.dataName = ''
      const indexCtg = this.data_options_categories.findIndex(
        (p) => p.id === this.dataCategoryProd
      );
      this.dataShapeProd =
        this.data_options_categories[indexCtg].productcategoryshape.name_en;
      this.dataShapeIdProd =
        this.data_options_categories[indexCtg].productcategoryshape.id;


      this.dataNameProdEN = null;
      this.dataNameProdFR = null;
      this.dataNameProdES = null;
      this.dataNameProdDE = null;
      this.dataNameProdNL = null;
      this.dataNameProd = null;
      this.dataNameProdRO = null;
      this.dataVolumeProd = null;
      this.uomLockedProd = true;


      // CYLINDRE
      /*
        this.dataRadiusProd = null;
        this.dataHeightProd = null;
        this.dataWidthProd = null;
        this.dataDiameterProd = null;
        this.dataPerimeter_MinProd = null;
        this.dataPerimeter_MaxProd = null;
        this.dataPerimeter_AvgProd = null;
        this.dataVolumeProd = null;
        this.dataNbStakesProd = null;
        this.dataLengthProd = null;
        this.dataSpacing_MinProd = null;
        this.dataSpacing_AvgProd = null;
        this.dataSpacing_MaxProd = null;
        this.dataRollerLengthProd = null;
      */
      if (this.dataShapeIdProd === 1) {
        this.dataUomProd = this.data_options_uoms[0].id;
        this.dataRadiusProd = null;
        this.dataHeightProd = null;
        this.dataWidthProd = null;
        //this.dataDiameterProd = null;
        this.dataPerimeter_MinProd = null;
        this.dataPerimeter_MaxProd = null;
        this.dataPerimeter_AvgProd = null;
        this.dataVolumeProd = null;
        this.dataNbStakesProd = null;
        //this.dataLengthProd = null;
        this.dataSpacing_MinProd = null;
        this.dataSpacing_AvgProd = null;
        this.dataSpacing_MaxProd = null;
        this.dataRollerLengthProd = null;
        this.uomLockedProd = true;
      }
      if (this.dataShapeIdProd === 2) {
        this.dataUomProd = this.data_options_uoms[0].id;
        this.dataRadiusProd = null;
        this.dataHeightProd = null;
        this.dataWidthProd = null;
        this.dataDiameterProd = null;
        //this.dataPerimeter_MinProd = null;
        //this.dataPerimeter_MaxProd = null;
        //this.dataPerimeter_AvgProd = null;
        this.dataVolumeProd = null;
        this.dataNbStakesProd = null;
        //this.dataLengthProd = null;
        this.dataSpacing_MinProd = null;
        this.dataSpacing_AvgProd = null;
        this.dataSpacing_MaxProd = null;
        this.dataRollerLengthProd = null;
        this.uomLockedProd = true;
      }
      if (this.dataShapeIdProd === 3) {
        this.dataUomProd = this.data_options_uoms[0].id;
        this.dataRadiusProd = null;
        this.dataHeightProd = null;
        this.dataWidthProd = null;
        this.dataDiameterProd = null;
        //this.dataPerimeter_MinProd = null;
        //this.dataPerimeter_MaxProd = null;
        //this.dataPerimeter_AvgProd = null;
        this.dataVolumeProd = null;
        this.dataNbStakesProd = null;
        //this.dataLengthProd = null;
        this.dataSpacing_MinProd = null;
        this.dataSpacing_AvgProd = null;
        this.dataSpacing_MaxProd = null;
        this.dataRollerLengthProd = null;
        this.uomLockedProd = true;
      }
      if (this.dataShapeIdProd === 4) {
        this.dataUomProd = this.data_options_uoms[0].id;
        this.dataRadiusProd = null;
        //this.dataHeightProd = null;
        //this.dataWidthProd = null;
        this.dataDiameterProd = null;
        this.dataPerimeter_MinProd = null;
        this.dataPerimeter_MaxProd = null;
        this.dataPerimeter_AvgProd = null;
        this.dataVolumeProd = null;
        this.dataNbStakesProd = null;
        //this.dataLengthProd = null;
        this.dataSpacing_MinProd = null;
        this.dataSpacing_AvgProd = null;
        this.dataSpacing_MaxProd = null;
        this.dataRollerLengthProd = null;
        this.uomLockedProd = true;
      }
      if (this.dataShapeIdProd === 5) {
        this.dataUomProd = this.data_options_uoms[1].id;
        this.dataRadiusProd = null;
        this.dataHeightProd = null;
        this.dataWidthProd = null;
        this.dataDiameterProd = null;
        this.dataPerimeter_MinProd = null;
        this.dataPerimeter_MaxProd = null;
        this.dataPerimeter_AvgProd = null;
        this.dataVolumeProd = 1;
        this.dataNbStakesProd = null;
        this.dataLengthProd = null;
        this.dataSpacing_MinProd = null;
        this.dataSpacing_AvgProd = null;
        this.dataSpacing_MaxProd = null;
        this.dataRollerLengthProd = null;
        this.uomLockedProd = true;
      }
      if (this.dataShapeIdProd === 6) {
        this.dataUomProd = this.data_options_uoms[0].id;
        this.dataRadiusProd = null;
        this.dataHeightProd = null;
        this.dataWidthProd = null;
        this.dataDiameterProd = null;
        this.dataPerimeter_MinProd = null;
        this.dataPerimeter_MaxProd = null;
        this.dataPerimeter_AvgProd = null;
        this.dataVolumeProd = null;
        this.dataNbStakesProd = null;
        this.dataLengthProd = null;
        this.dataSpacing_MinProd = null;
        this.dataSpacing_AvgProd = null;
        this.dataSpacing_MaxProd = null;
        this.dataRollerLengthProd = null;
        this.uomLockedProd = true;
      }
      if (this.dataShapeIdProd === 7) {
        this.dataUomProd = this.data_options_uoms[0].id;
        //this.dataRadiusProd = null;
        this.dataHeightProd = null;
        this.dataWidthProd = null;
        this.dataDiameterProd = null;
        //this.dataPerimeter_MinProd = null;
        //this.dataPerimeter_MaxProd = null;
        //this.dataPerimeter_AvgProd = null;
        this.dataVolumeProd = null;
        //this.dataNbStakesProd = null;
        //this.dataLengthProd = null;
        //this.dataSpacing_MinProd = null;
        //this.dataSpacing_AvgProd = null;
        //this.dataSpacing_MaxProd = null;
        //this.dataRollerLengthProd = null;
        this.uomLockedProd = true;
      }
      if (this.dataShapeIdProd === 8) {
        this.dataUomProd = this.data_options_uoms[0].id;
        this.dataRadiusProd = null;
        this.dataHeightProd = null;
        this.dataWidthProd = null;
        this.dataDiameterProd = null;
        this.dataPerimeter_MinProd = null;
        this.dataPerimeter_MaxProd = null;
        this.dataPerimeter_AvgProd = null;
        this.dataVolumeProd = null;
        this.dataNbStakesProd = null;
        this.dataLengthProd = null;
        this.dataSpacing_MinProd = null;
        this.dataSpacing_AvgProd = null;
        this.dataSpacing_MaxProd = null;
        this.dataRollerLengthProd = null;
        this.uomLockedProd = true;
      }

      if (
        this.dataShapeIdProd === 1 &&
        this.dataLengthProd &&
        this.dataDiameterProd
      ) {
        var diameterplusun = parseFloat(this.dataDiameterProd) + 1;
        var diametermoinsun = this.dataDiameterProd - 1;
        var rangediameter = diametermoinsun + "-" + diameterplusun;
        this.dataNameProdEN =
          /*this.data_options_categories[indexCtg].name_en+*/ "L" +
          this.dataLengthProd +
          "m * d[" +
          rangediameter +
          "]cm";
        axios
          .get(
            "/getvolume/" +
            this.dataShapeIdProd +
            "/" +
            this.dataDiameterProd / 2 +
            "/" +
            this.dataLengthProd * 100
          )
          .then((response) => {
            this.dataVolumeProd = response.data;
          });
      } else if (
        this.dataShapeIdProd === 2 &&
        this.dataLengthProd &&
        this.dataPerimeter_MaxProd &&
        this.dataPerimeter_MinProd
      ) {
        this.dataPerimeter_AvgProd =
          (parseFloat(this.dataPerimeter_MaxProd) +
            parseFloat(this.dataPerimeter_MinProd)) /
          2;
        var rangeP =
          this.dataPerimeter_MinProd + "-" + this.dataPerimeter_MaxProd;
        this.dataNameProdEN =
          /*this.data_options_categories[indexCtg].name_en+*/ "L" +
          this.dataLengthProd +
          "m * P[" +
          rangeP +
          "]cm";

        axios
          .get(
            "/getvolume/" +
            this.dataShapeIdProd +
            "/" +
            this.dataPerimeter_AvgProd +
            "/" +
            this.dataLengthProd * 100
          )
          .then((response) => {
            this.dataVolumeProd = response.data;
          });
      } else if (
        this.dataShapeIdProd === 3 &&
        this.dataLengthProd &&
        this.dataPerimeter_MaxProd &&
        this.dataPerimeter_MinProd
      ) {
        this.dataPerimeter_AvgProd =
          (parseFloat(this.dataPerimeter_MaxProd) +
            parseFloat(this.dataPerimeter_MinProd)) /
          2;
        var rangeP =
          this.dataPerimeter_MinProd + "-" + this.dataPerimeter_MaxProd;
        this.dataNameProdEN =
          /*this.data_options_categories[indexCtg].name_en+*/ "L" +
          this.dataLengthProd +
          "m * P[" +
          rangeP +
          "]cm";

        axios
          .get(
            "/getvolume/" +
            this.dataShapeIdProd +
            "/" +
            this.dataPerimeter_AvgProd +
            "/" +
            this.dataLengthProd * 100
          )
          .then((response) => {
            this.dataVolumeProd = response.data;
          });
      } else if (
        this.dataShapeIdProd === 4 &&
        this.dataLengthProd &&
        this.dataWidthProd &&
        this.dataHeightProd
      ) {
        this.dataNameProdEN =
          /*this.data_options_categories[indexCtg].name_en+*/ "L" +
          this.dataLengthProd +
          "m * W" +
          this.dataWidthProd +
          "cm *  H" +
          this.dataHeightProd +
          "cm";
        axios
          .get(
            "/getvolume/" +
            this.dataShapeIdProd +
            "/" +
            this.dataLengthProd * 100 +
            "/" +
            this.dataWidthProd +
            "/" +
            this.dataHeightProd
          )
          .then((response) => {
            this.dataVolumeProd = response.data;
          });
      } else if (
        this.dataShapeIdProd === 7 &&
        this.dataLengthProd &&
        this.dataPerimeter_MaxProd &&
        this.dataPerimeter_MinProd &&
        this.dataSpacing_MinProd &&
        this.dataSpacing_MaxProd &&
        this.dataRollerLengthProd
      ) {
        this.dataPerimeter_AvgProd =
          (parseFloat(this.dataPerimeter_MaxProd) +
            parseFloat(this.dataPerimeter_MinProd)) /
          2;
        this.dataSpacing_AvgProd =
          (parseFloat(this.dataSpacing_MaxProd) +
            parseFloat(this.dataSpacing_MinProd)) /
          2;
        axios
          .get(
            "/getvolume/77/" +
            this.dataPerimeter_AvgProd +
            "/" +
            this.dataLengthProd * 100
          )
          .then((response) => {
            this.dataRadiusProd = response.data;
            if (isEditingTheNbOfStake != true)
              this.dataNbStakesProd =
                (this.dataRollerLengthProd * 100) /
                (this.dataRadiusProd + this.dataSpacing_AvgProd);
          })
          .then((rs) => {
            axios
              .get(
                "/getvolume/3/" +
                this.dataPerimeter_AvgProd +
                "/" +
                this.dataLengthProd * 100
              )
              .then((response) => {
                if (this.dataNbStakesProd != null) {
                  this.dataVolumeProd = response.data * this.dataNbStakesProd;
                  var rangeP =
                    this.dataPerimeter_MinProd +
                    "-" +
                    this.dataPerimeter_MaxProd;
                  this.dataNameProdEN =
                    "L" +
                    this.dataRollerLengthProd +
                    "m * H" +
                    this.dataLengthProd +
                    "m Spacing:" +
                    this.dataSpacing_AvgProd +
                    "cm (" +
                    parseFloat(this.dataNbStakesProd).toFixed(0) +
                    " * P[" +
                    rangeP +
                    "]cm)";
                } else this.dataNameProdEN = null;
              });
          });
      }
    },
    async getOptionsCategories() {
      axios.get("/productcategory/active/data").then((response) => {
        this.data_options_categories = [...response.data];
      });
    },
    async getOptionsUoms() {
      axios.get("/product/uoms/data").then((response) => {
        this.data_options_uoms = [...response.data];
      });
    },
    EditCurrency(idcurrency) {
      if (idcurrency === 1) {
        /*this.$vs.loading({
          container: "#div-with-loading-ron",
          scale: 0.6,
        });*/
      } else {
        /*this.$vs.loading({
          container: "#div-with-loading-eur",
          scale: 0.6,
        });*/
      }
      /*axios
        .get("/currency/")
        .then((response) => {
          var data_currency = response.data.eur_ron;
          /*this.$vs.notify({
            color: "success",
            title: "Exchange Rate",
            text: "The Exchange Rate: " + data_currency
          });*/
      if (idcurrency === 1) {
        this.dataUnitPriceRon = (
          this.dataUnitPrice * localStorage.getItem("rate_eur_ron")
        ).toFixed(2);
        //this.$vs.loading.close("#div-with-loading-ron > .con-vs-loading");
      } else {
        this.dataUnitPrice = (
          this.dataUnitPriceRon / localStorage.getItem("rate_eur_ron")
        ).toFixed(2);
        //this.$vs.loading.close("#div-with-loading-eur > .con-vs-loading");
      }
      this.SetVolumeTotalAndPriceTotalLive();
      /*})
        .catch((err) => {
          if (idcurrency === 1)
            this.dataUnitPriceRon = (this.dataUnitPrice * localStorage.getItem('rate_eur_ron')).toFixed(4);
          else this.dataUnitPrice = (this.dataUnitPriceRon / localStorage.getItem('rate_eur_ron')).toFixed(4);
          this.$vs.loading.close("#div-with-loading-eur > .con-vs-loading");
          this.SetVolumeTotalAndPriceTotalLive();
        });*/
    },
    acceptAlert() {
      this.submitDataProd();
    },
    openPrompt() {
      try {
        const indexCtg = this.data_options_categories.findIndex(
          (p) => p.id === this.dataProductCategoryId.value
        );
        this.dataCategoryProd = this.data_options_categories[indexCtg].id;
        this.changeNameProd();
      } catch (error) { }
      this.$emit("closeSidebar");
      //this.initValues();
    },
    closePrompt() {
      this.clearValMultiple();
      this.$parent.$parent.toggleDataSidebar(true);
    },
    clearValMultiple() {
      (this.dataNameProdEN = ""),
        (this.dataNameProdFR = ""),
        (this.dataNameProdES = ""),
        (this.dataNameProdDE = ""),
        (this.dataNameProdNL = ""),
        (this.dataNameProdRO = ""),
        (this.dataRadiusProd = null),
        (this.dataPerimeter_MinProd = null),
        (this.dataPerimeter_MaxProd = null),
        (this.dataPerimeter_AvgProd = null),
        (this.dataSpacing_MinProd = null),
        (this.dataSpacing_MaxProd = null),
        (this.dataSpacing_AvgProd = null),
        (this.dataNbStakesProd = null),
        (this.dataRollerLengthProd = null),
        (this.dataDiameterProd = null),
        (this.dataLengthProd = null),
        (this.dataWidthProd = null),
        (this.dataHeightProd = null),
        (this.dataIsActiveProd = true),
        (this.dataVolumeProd = null),
        (this.dataCategoryProd = null),
        (this.dataUomProd = null);
    },
    getStockToday(idprod) {
      this.currentStock = "0.00";
      axios.get("/getstocktoday/" + idprod).then((response) => {
        this.currentStock = response.data;
      });
    },
    getProductCategoryList() {
      axios
        .get("/productcategory/active-combobox-wood/data")
        .then((response) => {
          this.data_options_product_category = [...response.data];
        });
    },
    getProductList() {
      (this.dataProductId = ""),
        (this.dataVolume = ""),
        (this.dataQuantity = ""),
        (this.dataUom = ""),
        (this.dataVolumeTotal = ""),
        (this.dataUnitPrice = ""),
        (this.dataUnitPriceRon = ""),
        (this.dataTheoreticalPrice = ""),
        (this.dataTotalPrice = ""),
        (this.dataTotalPriceRon = ""),
        axios
          .get(
            "/product/active-combobox/data/" +
            this.dataProductCategoryId.value
          )
          .then((response) => {
            this.data_options_product = [...response.data];
          });
    },
    getProductData() {
      //ICI2025
      this.dataUnitPricePerM3 = null;
      this.dataVolume = null;
      this.dataVolumeTotal = null;
      this.dataQuantity = null;
      this.dataUnitPrice = null;
      this.dataUnitPricePerM2 = null;
      this.dataUnitPriceRon = null;
      this.dataTotalPrice = null;
      this.dataTotalPriceRon = null;


      axios
        .get("/product/data/" + this.dataProductId.value)
        .then((response) => {
          this.dataVolume = response.data.volume;
          this.dataUom = response.data.uomsreference.name_en;
          this.dataTheoreticalPrice = response.data.productcategory.price;
          this.getStockToday(this.dataProductId.value);
          this.getLatestPrice();
          this.getRefPrice();
          this.lastProductData = response.data;
          this.showCatalogPriceSuggestion(response.data);

          // Proposition de TVA pour ce produit ("lemn de foc" à taux réduit).
          // Sans force: no-op si la facture a déjà une TVA enregistrée — ajouter
          // une ligne ne doit pas déplacer le taux du document.
          if (this.$parent && this.$parent.$parent && this.$parent.$parent.updateTvaForFirewood) {
            this.$parent.$parent.updateTvaForFirewood(this.dataProductId.value);
          }


          //ICI2025)
          if (response.data.length && response.data.width) {
            this.dataSurface = (
              ((response.data.width / 10000) * response.data.length)).toFixed(2);
            this.containsWidthLength = true;
          }
          else {
            this.dataSurface = 0;
            this.containsWidthLength = false;
          }


          if (response.data.length) {
            this.dataLength = parseFloat(response.data.length / 100).toFixed(2);
            this.containsLength = true;
          }
          else {
            this.dataLength = 0;
            this.containsLength = false
          }

          if (response.data.rollerlength) {
            this.dataLength = parseFloat(response.data.rollerlength).toFixed(2);
            this.containsLength = true;
          }

          if (response.data.width) {
            this.dataWidth = parseFloat(response.data.width / 100).toFixed(2);
          }
          else {
            this.dataWidth = 0;
          }
        });
    },
    SetProductName() {
      this.dataName =
        this.dataProductCategoryId.label + " " + this.dataProductId.label;
      this.dataDescription = this.dataName;
    },
    SetVolumeTotalAndPriceTotalLive() {
      //ICI2025
      this.dataLengthTotal = ((this.dataLength * this.dataQuantity)).toFixed(2);
      this.dataSurfaceTotal = ((this.dataSurface * this.dataQuantity)).toFixed(2);
      this.dataVolumeTotal = (this.dataVolume * this.dataQuantity).toFixed(4);
      this.dataTotalPrice = (this.dataQuantity * this.dataUnitPrice).toFixed(4);
      this.dataTotalPriceRon = (
        this.dataQuantity * this.dataUnitPriceRon
      ).toFixed(4);
      this.syncTtcEdits();
    },
    initValues() {
      if (this.data.id) return;
      (this.dataProductId = ""),
        (this.dataVolume = ""),
        (this.dataQuantity = ""),
        (this.dataUom = ""),
        (this.dataUomId = ""),
        (this.dataVolumeTotal = ""),
        (this.dataUnitPrice = ""),
        (this.dataTheoreticalPrice = ""),
        (this.dataTotalPrice = ""),
        (this.dataTotalPriceRon = ""),
        (this.dataName = ""),
        (this.dataDescription = ""),
        (this.dataUnitPricePerM3 = "");
    },
    submitData() {
      if (
        parseFloat(this.dataQuantity) > 0 &&
        parseFloat(this.dataUnitPrice) >= 0
      ) {
        this.$validator.validateAll().then((result) => {
          if (result) {
            var obj = {};
            var idoperation = null;
            if (this.data.idoperation) idoperation = this.data.idoperation;
            else idoperation = this.data.operations_products.idoperation;

            if (this.dataDescription) {
            } else {
              this.dataDescription = this.dataName;
            }
            // En mode édition, toujours utiliser this.data.id, ignorer dataProductId
            if (this.data.id !== null && this.data.id >= -100) {
              // Mode édition - utiliser l'ID du produit existant
              if (this.data.id == 5 || this.data.id == 6 || this.data.id <= -1) {
                obj = {
                  idoperation: idoperation,
                  idproduct: this.data.id,
                  quantity: +Math.abs(this.dataQuantity),
                  price: -Math.abs(this.dataUnitPrice),
                  price_ron: -Math.abs(this.dataUnitPriceRon),
                  description: this.dataDescription,
                  who: localStorage.getItem("login-username")
                };
              } else {
                obj = {
                  idoperation: idoperation,
                  idproduct: this.data.id,
                  quantity: -Math.abs(this.dataQuantity),
                  price: Math.abs(this.dataUnitPrice),
                  price_ron: Math.abs(this.dataUnitPriceRon),
                  description: this.dataDescription,
                  who: localStorage.getItem("login-username")
                };
              }
            } else if (this.dataProductId.value) {
              // Mode création - utiliser dataProductId
              //cas ristourne
              if (this.dataProductId.value <= -1) {
                obj = {
                  idoperation: idoperation,
                  idproduct: this.dataProductId.value,
                  quantity: Math.abs(this.dataQuantity),
                  price: -Math.abs(this.dataUnitPrice),
                  price_ron: -Math.abs(this.dataUnitPriceRon),
                  description: this.dataDescription,
                  who: localStorage.getItem("login-username")
                };
              } else {
                obj = {
                  idoperation: idoperation,
                  idproduct: this.dataProductId.value,
                  quantity: -Math.abs(this.dataQuantity),
                  price: Math.abs(this.dataUnitPrice),
                  price_ron: Math.abs(this.dataUnitPriceRon),
                  description: this.dataDescription,
                  who: localStorage.getItem("login-username")
                };
              }
            }
            if (this.data.id !== null && this.data.id >= -100) {
              this.$store
                .dispatch("operationList/updateItem", obj)
                .then((res) => {
                  this.$store
                    .dispatch("operationList/fetchm3difference", idoperation)
                    .then((res) => { })
                    .catch((err) => {
                      if (err.response.status === 404) {
                        this.user_not_found = true;
                        return;
                      }
                      console.error(err);
                    });
                  this.$vs.notify({
                    color: "success",
                    title: "Product Updated!",
                    text: "The product was successfully updated",
                  });
                  this.$emit("closeSidebar");
                  this.initValues();
                })
                .catch((err) => {
                  console.error(err);
                  this.$vs.notify({
                    color: "danger",
                    title: "You cannot add 2 times the same product!",
                    text: "The product was NOT updated",
                  });
                });
            } else {
              delete obj.id;
              this.$store
                .dispatch("operationList/createItem", obj)
                .then((res) => {
                  this.$store
                    .dispatch("operationList/fetchm3difference", idoperation)
                    .then((res) => { })
                    .catch((err) => {
                      if (err.response.status === 404) {
                        this.user_not_found = true;
                        return;
                      }
                      console.error(err);
                    });
                  this.$vs.notify({
                    color: "success",
                    title: "Product Created!",
                    text: "The product was successfully added",
                  });
                  this.$emit("closeSidebar");
                  this.initValues();
                })
                .catch((err) => {
                  console.error(err);
                  this.$vs.notify({
                    color: "danger",
                    title: "You cannot add 2 times the same product!",
                    text: "The product was NOT added",
                  });
                });
            }
          }
        });
      } else {
        this.$vs.notify({
          color: "danger",
          title: "You cannot add negative value!",
          text: "The product was NOT added",
        });
      }
    },
  },
  created() {
    this.getProductCategoryList();
    this.getOptionsCategories();
    this.getOptionsUoms();
    this.getRefPrice();
    if (!moduleDataListProduct.isRegistered) {
      this.$store.registerModule("dataListProduct", moduleDataListProduct);
      moduleDataListProduct.isRegistered = true;
    }
    this.$store.dispatch("dataListProduct/fetchDataListItems");
    if (localStorage.getItem("login-roles").toLowerCase().includes("admin")) {
      this.displayExport = true;
    }
  },
};
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>
